
// ================================================================================================

function ApplyClickEvents() {

    var $buttonBar = $modal.find('.m-modal__button-bar');

    // Cancel button
    $buttonBar.find('#m-modal__btn-close').click(function () {
        CloseModal();
    });

    // Discussion button
    $buttonBar.find('#m-modal__btn-discussion').click(function () {
        OpenModal('discussion');
    });

    // Error panel
    $('#m-modal__btn-ok-on-error').click(function () {
        $('.m-modal__notification--error').hide();
    });
}

// ================================================================================================
